import type {
	CreateSensorRequest,
	Floor,
	Location,
	Sensor,
	ShadowCreateFloorRequest,
	ShadowCreateZoneRequest,
	Zone,
} from "@sitescene/types";

import { useMutation } from "@tanstack/react-query";

import type { CreateLocationRequest } from "@/api/locations";

import { floorsApi } from "@/api/floors";
import { installationsApi } from "@/api/installations";
import { locationsApi } from "@/api/locations";
import { sensorsApi } from "@/api/sensors";
import { zonesApi } from "@/api/zones";

import { useInvalidateMapQueries } from "./useInvalidateMapQueries";

export const useCreateInstallation = () => {
	const invalidate = useInvalidateMapQueries();
	return useMutation({
		mutationFn: (body: { externalId: string; location: string }) =>
			installationsApi.createInstallation(body),
		onSuccess: () => {
			invalidate();
		},
	});
};

export const useCreateLocation = () => {
	const invalidate = useInvalidateMapQueries();
	return useMutation({
		mutationFn: (body: CreateLocationRequest): Promise<Location> =>
			locationsApi.createLocation(body),
		onSuccess: () => {
			invalidate();
		},
	});
};

export const useCreateFloor = () => {
	const invalidate = useInvalidateMapQueries();
	return useMutation({
		mutationFn: (body: ShadowCreateFloorRequest): Promise<Floor> =>
			floorsApi.createFloor(body),
		onSuccess: () => {
			invalidate();
		},
	});
};

export const useCreateZone = () => {
	const invalidate = useInvalidateMapQueries();
	return useMutation({
		mutationFn: (body: ShadowCreateZoneRequest): Promise<Zone> =>
			zonesApi.createZone(body),
		onSuccess: () => {
			invalidate();
		},
	});
};

export const useCreateSensor = () => {
	const invalidate = useInvalidateMapQueries();
	return useMutation({
		mutationFn: (body: CreateSensorRequest): Promise<Sensor> =>
			sensorsApi.createSensor(body),
		onSuccess: () => {
			invalidate();
		},
	});
};
